import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

//Calendar
const Calendar = () =>
    import( /* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');

//Charts
const Charts = () =>
    import( /* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () =>
    import( /* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () =>
    import( /* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () =>
    import( /* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');

const Icons = () =>
    import( /* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () =>
    import( /* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () =>
    import( /* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () =>
    import( /* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () =>
    import( /* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () =>
    import( /* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () =>
    import( /* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () =>
    import( /* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

const Pricing = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () =>
    import( /* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () =>
    import( /* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () =>
    import( /* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () =>
    import( /* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Sales Functions pages
const Customers = () =>
    import( /* webpackChunkName: "forms" */ '@/views/customers/master.vue');
const Customer = () =>
    import( /* webpackChunkName: "forms" */ '@/views/customers/details.vue');
const Vendors = () =>
    import( /* webpackChunkName: "forms" */ '@/views/vendors/master.vue');
const Vendor = () =>
    import( /* webpackChunkName: "forms" */ '@/views/vendors/details.vue');
const PO = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/order.vue');
const POS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/orders.vue');
const PI = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/invoice.vue');
const PIS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/invoices.vue');
const CustomizedPrices = () =>
    import( /* webpackChunkName: "forms" */ '@/views/customers/customizedPrices.vue');
const Sales = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/master.vue');
const Quotation = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/quotation.vue');
const Quotations = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/quotations.vue');
const Order = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/order.vue');
const Orders = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/orders.vue');
const Invoice = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/invoice.vue');
const Invoices = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/invoices.vue');
const UploadDocumentsHKTVM = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/uploadDocumentsHKTVM.vue');

// Products Functions pages
const Products = () =>
    import( /* webpackChunkName: "forms" */ '@/views/products/master.vue');
const Product = () =>
    import( /* webpackChunkName: "forms" */ '@/views/products/details.vue');

const Receipt = () =>
    import( /* webpackChunkName: "forms" */ '@/views/receipts/salesreceipt.vue');
const Receipts = () =>
    import( /* webpackChunkName: "forms" */ '@/views/receipts/salesreceipts.vue');

// Sale Channel Pages
const SaleChannels = () =>
    import( /* webpackChunkName: "forms" */ '@/views/saleChannels/master.vue');
const SaleChannel = () =>
    import( /* webpackChunkName: "forms" */ '@/views/saleChannels/details.vue');

//sales product incident report
const SalesPIR = () =>
    import( /* webpackChunkName: "forms" */ '@/views/salesPIR/master.vue');

const ApprovalRequests = () =>
    import( /* webpackChunkName: "forms" */ '@/views/Notifications/approvalRequests.vue');


const Locations = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/locations.vue');

const Location = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/location.vue');


const stockcards = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stockcards.vue');

const stockcard = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stockcard.vue');

const stockin = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stockin.vue');

const stockout = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stockout.vue');


const stocktransfer = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stocktransfer.vue');

const stocktransfers = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stocktransfers.vue');

const stockcardDetails = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/stockcardDetails.vue');

const productInventory = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/productInventory.vue');

const invoiceFromDos = () =>
    import( /* webpackChunkName: "forms" */ '@/views/sales/invoiceFromDos.vue');

const invoiceFromGRN = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/invoiceFromGRNs.vue');

const GRNS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/grns.vue');

const GRN = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/grn.vue');

const TradeItemsPurchase = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/tradeItemsPurchase.vue');

const DOS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/dos.vue');

const DO = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/do.vue');

// const PickListWaybills = () =>
//     import( /* webpackChunkName: "forms" */ '@/views/inventory/picklistWaybills.vue');

const WaybillCalendar = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/waybillCalendar.vue');

const GTINEntry = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/gtinEntry.vue');    

const Picklist = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/picklist.vue');

const WaybillPack = () =>
    import( /* webpackChunkName: "forms" */ '@/views/inventory/waybillPack.vue');

const Users = () =>
    import( /* webpackChunkName: "forms" */ '@/views/users/master.vue');

const User = () =>
    import( /* webpackChunkName: "forms" */ '@/views/users/details.vue');

const COAS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/coa/master.vue');

const COA = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/coa/details.vue');

const Vouchers = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/vouchers/master.vue');

const Voucher = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/vouchers/details.vue');


const GLVouchers = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/glVouchers/master.vue');

const GLVoucher = () =>
    import( /* webpackChunkName: "forms" */ '@/views/finance/glVouchers/details.vue');

const ContactCategories = () =>
    import( /* webpackChunkName: "forms" */ '@/views/settings/contactCategories.vue');

const contactCategory = () =>
    import( /* webpackChunkName: "forms" */ '@/views/settings/contactCategory.vue');


const Systems = () =>
    import( /* webpackChunkName: "forms" */ '@/views/settings/systems.vue');

const System = () =>
    import( /* webpackChunkName: "forms" */ '@/views/settings/system.vue');


const DocumentScanning = () =>
    import( /* webpackChunkName: "forms" */ '@/views/purchases/documentScanning.vue');

const Assets = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assets/master.vue');

const Asset = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assets/details.vue');

const AssetClassifications = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assetClassifications/master.vue');

const AssetClassification = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assetClassifications/details.vue');

const AssetProtocols = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assetProtocols/master.vue');

const AssetProtocol = () =>
    import( /* webpackChunkName: "forms" */ '@/views/assetProtocols/details.vue');


const RFIDS = () =>
    import( /* webpackChunkName: "forms" */ '@/views/rfids/master.vue');

const RFID = () =>
    import( /* webpackChunkName: "forms" */ '@/views/rfids/details.vue');

const rfidUpload = () =>
    import( /* webpackChunkName: "forms" */ '@/views/rfids/uploadFile.vue');

let componentsMenu = {
    path: '/components',
    component: DashboardLayout,
    redirect: '/components/buttons',
    name: 'Components',
    children: [{
        path: 'buttons',
        name: 'Buttons',
        component: Buttons,
        meta: {
            requireAuth: true
        }
    },
    {
        path: 'cards',
        name: 'Cards',
        component: Cards,
        meta: {
            requireAuth: true
        }
    },
    {
        path: 'grid-system',
        name: 'Grid System',
        component: GridSystem,
        meta: {
            requireAuth: true
        }
    },
    {
        path: 'icons',
        name: 'Icons',
        component: Icons,
        meta: {
            requireAuth: true
        }
    },
    {
        path: 'typography',
        name: 'Typography',
        component: Typography,
        meta: {
            requireAuth: true
        }
    }
    ]
};
let formsMenu = {
    path: '/forms',
    component: DashboardLayout,
    redirect: '/forms/elements',
    name: 'Forms',
    children: [{
        path: 'elements',
        name: 'Form elements',
        component: FormElements,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'components',
        name: 'Form components',
        component: FormComponents,
        meta: {
            requireAuth: true
        }
    },
    {
        path: 'validation',
        name: 'Form validation',
        component: FormValidation,
        meta: {
            requireAuth: true
        }
    }
    ]
};

let salesMenu = {
    path: '/sales',
    component: DashboardLayout,
    redirect: '/sales/customers',
    name: 'SALES',
    children: [{
        path: 'customers',
        name: 'CUSTOMERS',
        component: Customers,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'customer/:id',
        name: 'CUSTOMER',
        component: Customer,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'customized-prices',
        name: 'CUSTOMIZED_PRICES',
        component: CustomizedPrices,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'salechannels',
        name: 'SALE_CHANNELS',
        component: SaleChannels,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'salechannel/:id',
        name: 'SALE_CHANNEL',
        component: SaleChannel,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-documents',
        name: 'SALES_DOCUMENTS',
        component: Sales,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-quotations',
        name: 'SALES_QUOTATIONS',
        component: Quotations,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-quotation/`:id`',
        name: 'SALES_QUOTATION',
        component: Quotation,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-orders',
        name: 'SALES_ORDERS',
        component: Orders,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-order/:id',
        name: 'SALES_ORDER',
        component: Order,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-invoices',
        name: 'SALES_INVOICES',
        component: Invoices,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-invoice/:id',
        name: 'SALES_INVOICE',
        component: Invoice,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-invoice-from-do/:id',
        name: 'INVOICE_FROM_DO',
        component: invoiceFromDos,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-product-incident',
        name: 'PRODUCT_INCIDENT_REPORT',
        component: SalesPIR,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-receipts',
        name: 'SALES_RECEIPTS',
        component: Receipts,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'sales-receipt/:id',
        name: 'SALES_RECEIPT',
        component: Receipt,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'upload-documents-hktvm',
        name: 'UPLOAD_DOCUMENT_HKTVM',
        component: UploadDocumentsHKTVM,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let purchaseMenu = {
    path: '/purchase',
    component: DashboardLayout,
    redirect: '/purchase/vendors',
    name: 'PURCHASE',
    children: [
        {
            path: 'vendors',
            name: 'VENDORS',
            component: Vendors,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'vendor/:id',
            name: 'VENDOR',
            component: Vendor,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'trade-items-purchase',
            name: 'TRADE_ITEMS_PURCHASE',
            component: TradeItemsPurchase,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-orders',
            name: 'PURCHASE_ORDERS',
            component: POS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-order/:id',
            name: 'PURCHASE_ORDER',
            component: PO,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-invoices',
            name: 'PURCHASE_INVOICES',
            component: PIS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-invoice/:id',
            name: 'PURCHASE_INVOICE',
            component: PI,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-invoice-from-grn/:id',
            name: 'INVOICE_FROM_GRN',
            component: invoiceFromGRN,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'document-scanning',
            name: 'DOCUMENT_SCANNING',
            component: DocumentScanning,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};


let productsMenu = {
    path: '/products',
    component: DashboardLayout,
    redirect: '/master',
    name: 'PRODUCTS',
    children: [{
        path: 'master',
        name: 'PRODUCT_MASTER',
        component: Products,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'detail/:id',
        name: 'PRODUCT',
        component: Product,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let rfidsMenu = {
    path: '/rfids',
    component: DashboardLayout,
    redirect: '/master',
    name: 'RFIDS',
    children: [{
        path: 'master',
        name: 'RFIDS_MASTER',
        component: RFIDS,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'details/:id',
        name: 'RFID',
        component: RFID,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'upload-file',
        name: 'UPLOAD',
        component: rfidUpload,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let usersMenu = {
    path: '/users',
    component: DashboardLayout,
    redirect: '/master',
    name: 'USERS',
    children: [{
        path: 'master',
        name: 'USER_MASTER',
        component: Users,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'detail/:id',
        name: 'USER',
        component: User,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let financeMenu = {
    path: '/finance',
    component: DashboardLayout,
    redirect: '/chart-of-accounts',
    name: 'FINANCE',
    children: [
        {
            path: 'chart-of-accounts',
            name: 'CHART_OF_ACCOUNTS',
            component: COAS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'chart-of-accounts/:id',
            name: 'CHART_OF_ACCOUNT',
            component: COA,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'vouchers',
            name: 'VOUCHERS',
            component: Vouchers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'voucher/:id',
            name: 'VOCUHER',
            component: Voucher,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'gl-vouchers',
            name: 'GL_VOUCHERS',
            component: GLVouchers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'gl-voucher/:id',
            name: 'GL_VOUCHER',
            component: GLVoucher,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let tablesMenu = {
    path: '/tables',
    component: DashboardLayout,
    redirect: '/table/regular',
    name: 'Tables menu',
    children: [{
        path: 'regular',
        name: 'Tables',
        component: RegularTables,
        meta: { requireAuth: true }
    },
    {
        path: 'sortable',
        name: 'Sortable',
        component: SortableTables,
        meta: { requireAuth: true }
    },
    {
        path: 'paginated',
        name: 'Paginated Tables',
        component: PaginatedTables,
        meta: { requireAuth: true }
    }
    ]
};

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
    // {
    //     path: '/home',
    //     name: 'AUTHENTICATION_LOGIN',
    //     component: Home,
    //     meta: {
    //         noBodyBackground: true,
    //         requireAuth: false
    //     }
    // },
    {
        path: '/login',
        name: 'LOGIN',
        component: Login,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/register',
        name: 'REGISTER',
        component: Register,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: Pricing,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/lock',
        name: 'Lock',
        component: Lock,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '*',
        redirect: '/dashboard',
        component: NotFound,
        meta: {
            requireAuth: false
        }
    }
    ]
};


let inventoryMenu = {
    path: '/inventory',
    component: DashboardLayout,
    redirect: '/locations',
    name: 'INVENTORY',
    children: [
        {
            path: 'locations',
            name: 'LOCATIONS',
            component: Locations,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'location/:id',
            name: 'LOCATION',
            component: Location,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stockcards',
            name: 'STOCKCARDS',
            component: stockcards,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {

            path: 'stockcard-details/:id',
            name: 'STOCKCARD_DETAILS',
            component: stockcardDetails,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stockcard',
            name: 'STOCKCARD',
            component: stockcard,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stock-in',
            name: 'STOCK_IN',
            component: stockin,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stock-out',
            name: 'STOCK_OUT',
            component: stockout,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stocktransfers',
            name: 'STOCK_TRANSFERS',
            component: stocktransfers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stocktransfer/:id',
            name: 'STOCK_TRANSFER',
            component: stocktransfer,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'overview',
            name: 'OVERVIEW',
            component: productInventory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'grns',
            name: 'GOOD_RECEIVE_NOTES',
            component: GRNS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'grn/:id',
            name: 'GOOD_RECEIVE_NOTE',
            component: GRN,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'dos',
            name: 'DELIVERY_ORDERS',
            component: DOS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'do/:id',
            name: 'DELIVERY_ORDER',
            component: DO,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'waybill_calendar',
            name: 'WAYBILL_CALENDAR',
            component: WaybillCalendar,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        ,
        {
            path: 'gtin-entry',
            name: 'GTIN_Entry',
            component: GTINEntry,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path: 'picklist/:id',
            name: 'PICKLIST',
            component: Picklist,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'waybill_pack/:id',
            name: 'WAYBILL_PACK',
            component: WaybillPack,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },                
    ]
};

let settingsMenu = {
    path: '/settings',
    component: DashboardLayout,
    redirect: '/contact-categories',
    name: 'SETTINGS',
    children: [{
        path: 'contact-categories',
        name: 'CONTACT_CATEGORIES',
        component: ContactCategories,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'contact-categories/:id',
        name: 'CONTACT_CATEGORY',
        component: contactCategory,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'system-settings',
        name: 'SYSTEM_SETTINGS',
        component: Systems,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'system-settings/:id',
        name: 'SYSTEM_SETTING',
        component: System,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let assetsMenu = {
    path: '/assets-management',
    component: DashboardLayout,
    redirect: '/assets',
    name: 'ASSETS_MANAGEMENT',
    children: [{
        path: 'assets',
        name: 'ASSETS',
        component: Assets,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'asset/:id',
        name: 'ASSET',
        component: Asset,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]
};

let assetClassificationsMenu = {
    path: '/assetclassifications-management',
    component: DashboardLayout,
    redirect: '/asset-classifications',
    name: 'ASSET_CLASSIFICATIONS_MANAGEMENT',
    children: [{
        path: 'asset-classifications',
        name: 'ASSET_CLASSIFICATIONS',
        component: AssetClassifications,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'details/:id',
        name: 'ASSET_CLASSIFICATION',
        component: AssetClassification,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]

};

let assetProtocolsMenu = {
    path: '/assetprotocols-management',
    component: DashboardLayout,
    redirect: '/asset-protocols',
    name: 'ASSET_PROTOCOLS_MANAGEMENT',
    children: [{
        path: 'asset-protocols',
        name: 'ASSET_PROTOCOLS',
        component: AssetProtocols,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    },
    {
        path: 'details/:id',
        name: 'ASSET_PROTOCOL',
        component: AssetProtocol,
        meta: {
            navbarType: 'light',
            requireAuth: true
        }
    }
    ]

};

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
        name: 'Home',
        meta: {
            requireAuth: true
        }
    },
    componentsMenu,
    formsMenu,
    salesMenu,
    purchaseMenu,
    productsMenu,
    rfidsMenu,
    usersMenu,
    inventoryMenu,
    financeMenu,
    tablesMenu,
    settingsMenu,
    assetsMenu,
    assetClassificationsMenu,
    assetProtocolsMenu,
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dashboard',
        name: 'DASHBOARD',
        children:
            [
                // {
                //     path: 'alternative',
                //     name: 'DASHBOARD',
                //     component: Dashboard,
                //     meta: {
                //         requireAuth: true
                //     }
                // },
                {
                    path: 'dashboard',
                    name: 'DASHBOARD_SUMMARY',
                    component: AlternativeDashboard,
                    meta: {
                        navbarType: 'light',
                        requireAuth: true
                    }
                },
                {
                    path: 'approval-requests',
                    name: 'APPROVAL_REQUESTS',
                    component: ApprovalRequests,
                    meta: {
                        requireAuth: true,
                        navbarType: 'light',
                    }
                }
            ]
    },
    authPages,
];

export default routes;